import React from "react";
import { X, Download } from "lucide-react";

export default function PassengersModal({ cabins, onClose }) {
  const backend = process.env.REACT_APP_BACKEND_URL;
  const token = localStorage.getItem("tk_token");

  const downloadFile = async (kind /* "pdf" | "xlsx" */) => {
    const url = kind === "xlsx" ? `${backend}/api/export/passengers.xlsx` : `${backend}/api/export/passengers.pdf`;
    const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) { alert("Dosya oluşturulamadı"); return; }
    const blob = await res.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = kind === "xlsx" ? "Yolcu-Listesi.xlsx" : "Yolcu-Listesi.pdf";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(a.href);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end md:items-center justify-center bg-black/50 p-3" data-testid="pax-modal">
      <div className="tk-card w-full max-w-2xl p-0 overflow-hidden">
        <div className="p-4 flex items-center justify-between border-b" style={{ borderColor: "hsl(var(--border))" }}>
          <div>
            <h3 className="font-display font-semibold text-lg">Yolcu Listesi</h3>
            <p className="text-xs" style={{ color: "hsl(var(--text-2))" }}>Kabin bazında tüm yolcular</p>
          </div>
          <button data-testid="pax-close-btn" onClick={onClose} className="tk-btn-ghost !py-2 !px-2.5"><X className="w-4 h-4" /></button>
        </div>
        <div className="max-h-[55vh] overflow-y-auto p-3 space-y-2">
          {cabins.map((c) => (
            <div key={c.id} className="rounded-xl p-3" style={{ backgroundColor: "hsl(var(--surface-2))" }}>
              <div className="text-[10px] uppercase tracking-widest font-bold" style={{ color: "hsl(var(--text-2))" }}>Kabin {c.order} · {c.name}</div>
              <div className="mt-1.5 space-y-1.5">
                {(c.people || []).map((p, i) => (
                  <div key={i} className="text-sm flex flex-wrap gap-x-3 gap-y-0.5">
                    <span className="font-semibold">{p.full_name || "—"}</span>
                    {p.tc && <span style={{ color: "hsl(var(--text-2))" }}>TC: {p.tc}</span>}
                    {p.dob && <span style={{ color: "hsl(var(--text-2))" }}>Doğum: {new Date(p.dob).toLocaleDateString("tr-TR")}</span>}
                    {p.gender && <span className="tk-chip !py-0 !px-2">{p.gender === "K" ? "Kadın" : p.gender === "E" ? "Erkek" : p.gender}</span>}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="p-3 border-t flex gap-2" style={{ borderColor: "hsl(var(--border))" }}>
          <button data-testid="pax-download-xlsx-btn" onClick={() => downloadFile("xlsx")} className="tk-btn flex-1 flex items-center justify-center gap-1.5">
            <Download className="w-4 h-4" /> Excel
          </button>
          <button data-testid="pax-download-btn" onClick={() => downloadFile("pdf")} className="tk-btn flex-1 flex items-center justify-center gap-1.5">
            <Download className="w-4 h-4" /> PDF
          </button>
        </div>
      </div>
    </div>
  );
}
